import React from 'react';
import {
  ProspectCustomizeItemText,
  PoolProspectCustomizeItem,
  Prospect,
  useUpdateProspectCustomizeItemTextMutation,
} from 'api';
import {Input as UIInput} from 'components/antd';
import styled from 'styled-components';

interface Props {
  prospect: Prospect;
  poolProspectCustomizeItem: PoolProspectCustomizeItem;
}

export default ({prospect, poolProspectCustomizeItem}: Props) => {
  const customizeItem = prospect.customizeItemTexts.find(
    (item: ProspectCustomizeItemText) =>
      item.poolProspectCustomizeItemId === poolProspectCustomizeItem.id,
  );

  const [value, setValue] = React.useState(
    customizeItem ? customizeItem.value : '',
  );

  React.useEffect(() => {
    setValue(customizeItem ? customizeItem.value : '');
  }, [customizeItem]);

  const [updateCustomizeItem] = useUpdateProspectCustomizeItemTextMutation({});

  const update = (e: any) => {
    updateCustomizeItem({
      variables: {
        uuid: prospect.uuid,
        value: e.target.value,
        poolProspectCustomizeItemId: poolProspectCustomizeItem.id,
      },
    });
  };

  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={update}
      placeholder="未入力"
    />
  );
};

const Input = styled(UIInput.TextArea)`
  border-color: transparent;
  background-color: transparent;
  border-radius: 4px;

  &:hover {
    border: 1px solid var(--text-color-3);
  }
`;
